/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLiveBiddingLog } from '../fn/live-bidding-log/get-live-bidding-log';
import { GetLiveBiddingLog$Params } from '../fn/live-bidding-log/get-live-bidding-log';
import { LiveBiddingLogDto } from '../models/live-bidding-log-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedLiveBiddingLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLiveBiddingLog()` */
  static readonly GetLiveBiddingLogPath = '/api/live-bidding-log/{lotId}';

  /**
   * Gets the live-bidding-log for a specified lot.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLiveBiddingLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveBiddingLog$Response(params: GetLiveBiddingLog$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveBiddingLogDto>> {
    return getLiveBiddingLog(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the live-bidding-log for a specified lot.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLiveBiddingLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveBiddingLog(params: GetLiveBiddingLog$Params, context?: HttpContext): Observable<LiveBiddingLogDto> {
    return this.getLiveBiddingLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveBiddingLogDto>): LiveBiddingLogDto => r.body)
    );
  }

}
